import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components/Ui/index';
import { Slide } from '@material-ui/core';
import Warning from 'images/Warning.png';

import { GTM_TRACKING_TAGS } from 'utils/constants';
import styles from './styles.scss';

const ConfirmationDrawer = ({ open, onConfirm, onCancel, isVertPhone }) => (
  <Slide direction="up" in={open} mountOnEnter unmountOnExit>
    <div
      data-tracking={GTM_TRACKING_TAGS['Confirm Changes Model']}
      className={styles.confirmationModal}
      role="status"
      aria-live="polite"
    >
      <img src={Warning} alt="Warning" />
      <div className={classnames(styles.text, isVertPhone && styles.textPhone)}>
        Confirm before you go
      </div>
      <Button
        text="Cancel Changes"
        ariaLabel="Cancel Changes"
        className={styles.cancelButton}
        onClick={onCancel}
      />
      <Button
        text="Confirm Changes"
        ariaLabel="Confirm Changes"
        className={styles.confirmButton}
        onClick={onConfirm}
      />
    </div>
  </Slide>
);

ConfirmationDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isVertPhone: PropTypes.bool.isRequired,
};

export default ConfirmationDrawer;
